// React 
import React, { useState, useEffect } from 'react';

// Material UI
import { makeStyles, TextField, Button, Stack, Typography } from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';

// react router dom
import {Link,useNavigate} from "react-router-dom";

import LoadingComponent from "./LoadingComponent";

// firebase
import { useAuthState } from "react-firebase-hooks/auth";
import {
  auth,
  signInWithGoogle,
  loginWithEmailAndPassword,
} from "../firebase";

import { useDispatch, useSelector } from "react-redux";

import {
  userNotAuthenticated,
  userAuthSuccess,
  userAuthRequest,
  userAuthFailed,
} from "../store/Store"; 

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [user, loading, error] = useAuthState(auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(userAuthRequest());
    loginWithEmailAndPassword(email, password);
  };

  useEffect(()=>{
    if(loading){
      dispatch(userNotAuthenticated());
      return ;
    }
    if(user){
      dispatch(userAuthSuccess(user));
      navigate("/home");
    }
  },[loading,user]);

  useEffect(()=>{
    if(error){
      dispatch(userAuthFailed(error));
      navigate("/");
    }
  },[error]);

  return (

    !loading && !user ? 

    <div className="content">
      <form className="Login" onSubmit={handleSubmit}>
        <h1>Log-In</h1>
        <Stack spacing={2}>
          <TextField
            label="Email"
            variant="outlined"
            type="email"
            required
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
          <TextField
            label="Password"
            variant="outlined"
            type="password"
            required
            value={password}
            onChange={e => setPassword(e.target.value)}
          />

          <Button type="submit" variant="contained" color="success">
              Login
          </Button>
        </Stack>
      </form>
      <Stack spacing={2} className="options">
          <Button variant="contained" 
                  color="primary" 
                  startIcon={<GoogleIcon />}
                  onClick={signInWithGoogle}>
            Login With Google
          </Button>

          {/*
            <div>
              <Link to="/reset">Forgot Password</Link>
             </div> 
          */}
          
          <div>
            Don't have an account? <Link to="/signup">Register</Link> now.
          </div>
      </Stack>
    </div>

    : <LoadingComponent /> 
  );
};

export default Login;